import { useCompanyInformation, useCurrentLocale, useNewsroom } from '@prezly/theme-kit-nextjs';

import { SocialMedia } from '@/components';
import { LINKS, type Link } from '@/utils';

import { hasAnySocialMedia } from './utils';

import styles from './Boilerplate.module.scss';

function Boilerplate() {
    const companyInformation = useCompanyInformation();
    const { display_name } = useNewsroom();
    const currentLocale = useCurrentLocale();

    const hasSocialMedia = hasAnySocialMedia(companyInformation);

    const links = LINKS[currentLocale.toNeutralLanguageCode()] ?? {};

    function getLinkTitle(link: Link): string {
        const title = Object.keys(link)[0];

        return title;
    }

    function getLinkHref(link: Link): string {
        const title = Object.keys(link)[0];

        return link[title];
    }

    return (
        <div className={styles.container}>
            <div className="container">
                <div className={styles.columns}>
                    <div className={styles.aboutUs}>
                        {/* eslint-disable-next-line @next/next/no-img-element */}
                        <img
                            className={styles.logo}
                            src="/images/logo-footer.svg"
                            alt={display_name}
                        />
                        {hasSocialMedia && (
                            <SocialMedia
                                companyInformation={companyInformation}
                                className={styles.socialMedia}
                            />
                        )}
                    </div>
                    {Object.keys(links).map((title) => (
                        <div key={title}>
                            <h2 className={styles.heading}>{title}</h2>
                            {links[title].map((link) => (
                                <div
                                    className={styles.linkWrapper}
                                    key={`${title}-${getLinkHref(link)}`}
                                >
                                    <a
                                        className={styles.link}
                                        href={getLinkHref(link)}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {getLinkTitle(link)}
                                    </a>
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default Boilerplate;
